import {FC} from 'react'
import classNames from 'classnames'
import type {ProcedureCategory} from '../procedureTypes'
import styles from './ProcedureCategoryTab.scss'
import {Link} from 'react-router-dom'

interface Props {
  category: ProcedureCategory
  active?: boolean
}

export const ProcedureCategoryTab: FC<Props> = ({category, active}) => {
  const Icon = category.icon
  return (
    <Link className={classNames(styles.tab, active && styles.active)} to={`#${category.category}`}>
      <div className={styles.inner}>
        <Icon size={20} />
        <span>{category.title}</span>
      </div>
    </Link>
  )
}
